export function getErrorMessages(param) {
    return param.$errors.length > 0 ? param.$errors[0].$message : '';
}
